import api from './api';
import { Prediction, PredictionRequest } from '../types';

export const predictionService = {
  createPrediction: async (request: PredictionRequest): Promise<Prediction> => {
    const response = await api.post<Prediction>('/predictions', request);
    return response.data;
  },

  getPredictions: async (): Promise<Prediction[]> => {
    const response = await api.get<Prediction[]>('/predictions');
    return response.data;
  },

  getPrediction: async (id: number): Promise<Prediction> => {
    const response = await api.get<Prediction>(`/predictions/${id}`);
    return response.data;
  },

  updatePrediction: async (id: number, updates: { purchasePrice?: number | null; interestRate?: number | null }): Promise<Prediction> => {
    const response = await api.put<Prediction>(`/predictions/${id}`, updates);
    return response.data;
  },

  deletePrediction: async (id: number): Promise<void> => {
    await api.delete(`/predictions/${id}`);
  },
};

